import {Injectable} from "@angular/core";

@Injectable()
export class WindowService {

  openPrint() : void {
    window.print();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/services/window.service.ts